<div class="form-card">
  <div class="card-header">
    <div class="card-header-icon financeiro-icon">
      <i class="pi pi-wallet"></i>
    </div>
    <span class="card-header-title">{{ 'relatorio-contas-pagas.texts.relatorio_contas_pagas' | translate }}</span>
  </div>
  <div class="card-content">
    <div class="form-grid">

      <!-- Pessoa -->
      <div class="form-field col-7">
        <label class="form-label">{{ 'relatorio-contas-pagas.labels.selecionar_pessoa' | translate }}</label>
        <p-dropdown [options]="pessoas" [(ngModel)]="selectedPessoa" optionLabel="nome"
          [filter]="true" [filterBy]="'nome,fantasia,telefone,ci,ruc,nomeCidade,codigoPessoa'" [showClear]="true"
          [placeholder]="('relatorio-contas-pagas.placeholders.selecione' | translate)"
          (onFilter)="onPessoaFilter($event)" [loading]="loadingPessoas" appendTo="body" styleClass="w-full">

          <ng-template pTemplate="header">
            <div class="grid font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
              <div class="col-1">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
              <div class="col-3">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.nome_fantasia' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.telefone' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ci' | translate }}</div>
              <div class="col-2">{{ 'relatorio-itens-vendidos.table_headers.ruc' | translate }}</div>
            </div>
          </ng-template>

          <ng-template let-fornecedor pTemplate="item">
            <div class="grid px-2 py-1 text-sm">
              <div class="col-1">{{ fornecedor.codigoPessoa }}</div>
              <div class="col-3">{{ fornecedor.nome }}</div>
              <div class="col-2">{{ fornecedor.fantasia }}</div>
              <div class="col-2">{{ fornecedor.telefone }}</div>
              <div class="col-2">{{ fornecedor.ci }}</div>
              <div class="col-2">{{ fornecedor.ruc }}</div>
            </div>
          </ng-template>

          <ng-template pTemplate="empty">
            <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_fornecedor_encontrado' | translate }}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Período (componente compartilhado do dashboard) -->
      <div class="form-field col-4">
        <label class="form-label">{{ 'periodos_relatorio.selecione_o_periodo' | translate }}</label>
        <app-periodo-filtro modo="avancado" [valorPadrao]="'showAll'" [persistir]="true" [opcoes]="opcoesPeriodo" [textoExibicao]="periodoTexto"
          styleClass="w-full periodo-filtro-neutro" (periodoChanged)="onPeriodoChanged($event)"></app-periodo-filtro>
      </div>

      <!-- Botão Emitir -->
      <div class="form-field full">
        <div class="actions-container">
          <button pButton type="button" [disabled]="emitindoRelatorio" class="btn-primary"
            label="{{ 'relatorio-contas-pagas.buttons.emitir_relatorio' | translate }}" icon="pi pi-file-pdf"
            (click)="emitirRelatorio()">
          </button>
          <app-loading-dialog [visible]="emitindoRelatorio"
            title="{{ 'relatorios.texts.gerando_relatorio' | translate }}" />
        </div>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
